/**
 * Created by mukund on 2/17/16.
 */

'use strict';

angular.module('mediacloudApp')
    .factory('Tenant', function Principal($q, $resource) {
        var _tenantinfo;

        return {

            info: function(){
                var deferred = $q.defer();

                // check and see if we have retrieved the tenant info from the server.
                // if we have, reuse it by immediately resolving
                if (angular.isDefined(_tenantinfo)) {
                    deferred.resolve(_tenantinfo);

                    return deferred.promise;
                }

                // retrieve the tenant info from the server, and then resolve.
                $resource('api/tenant/info').get().$promise
                    .then(function (info) {
                        _tenantinfo = info;
                        deferred.resolve(_tenantinfo);
                    })
                    .catch(function() {
                        _tenantinfo = undefined;
                        deferred.resolve(_tenantinfo);
                    });
                return deferred.promise;
            }

        };
    });
